export enum HHDSButtonType {
  Primary = "primary",
  Secondary = "secondary",
  Overlay = "overlay",
  ScrollDown = "scroll-down",
  Round = "round",
  Close = "close",
}

export enum HHDSButtonMode {
  Light = "light",
  Dark = "dark",
}

export enum HHDSButtonWidth {
  Default = "default",
  Full = "full",
}
